<template>
  <div class="app-container">
    <div class="ruKuZuoyeWarp-body">
      <div>
        <!-- <div class="detailsTitle">
          <h4>入库单据</h4>
        </div> -->
        <!-- 查询条件 -->
        <div ref="searchBox" class="formBox margbot">
          <el-form :inline="true" :model="formData" class="demo-form-inline" size="mini" label-width="100px">
            <div class="formItemBox">
            <el-form-item label="入库单号:">
              <el-input v-model="formData.instockNo" placeholder="请输入库单号" size="mini" >
              </el-input>
            </el-form-item>
            <el-form-item label="一级货主:">
              <el-select  v-model="formData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
                <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                  :value="item.taxpayerNumber">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="二级货主:">
              <el-select  v-model="formData.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
                <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                  :value="item.taxpayerNumber">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="入库日期:">
              <div style="display: flex;">
              <el-date-picker v-model="formData.instockDateStart" size="mini" type="datetime" placeholder="选择入库日期"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              -
              <el-date-picker v-model="formData.instockDateEnd" size="mini" placeholder="选择入库日期"
                value-format="yyyy-MM-dd HH:mm:ss" type="datetime" ></el-date-picker>
                </div>
            </el-form-item>
            <el-form-item label="车辆号牌:">
              <el-input v-model="formData.instockPlateNumber" placeholder="请输入车号" size="mini"
               maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="到货方式:">
              <el-select v-model="formData.arrivalMethod" clearable placeholder="请选择" filterable size="mini">
                <el-option v-for="(item, index) in arrivalMethodData" :key="index" :label="item.label"
                  :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>
            </div>
            <el-form-item style="padding-left: 10px;">
              <el-button type="primary" size="mini" @click="chaxun" btnCode="00ZP002B001" v-if="btnFlg[0]">查询
              </el-button>
              <el-button type="primary" class="button" size="mini" @click="chongZhi" btnCode="00ZP002B002"
                v-if="btnFlg[1]">重置</el-button>
              <el-button type="primary" class="button" size="mini" @click="daYin" btnCode="00ZP002B003"
                v-if="btnFlg[2]">打印入库单</el-button>
                <!-- 首线联合打印20241227 -->
              <el-button type="primary" class="button" size="mini" @click="daYin(1)"
                v-if="btnFlg[4]">打印入库单</el-button>
              <el-button type="primary" class="button" size="mini" @click="daochu" btnCode="00ZP002B004"
                v-if="btnFlg[3]">导出</el-button>
               <el-button type="primary" class="button" size="mini" @click="uploadClick" :isDisable="isDisable"
                v-if="btnFlg[5]">上传凭证</el-button>
               <el-button type="primary" class="button" size="mini" @click="daYinBd" :isDisable="isDisable"
                v-if="btnFlg[6]">打印磅单</el-button>
            </el-form-item>
             <el-form-item style="padding-left: 10px;">
               <div style="padding-bottom: 5px;">
                  <span style="margin-left:10px;">总吨数：<span style="color: red">{{ totalTon }}</span>吨</span>
                  <span style="margin-left:10px;">总件数：<span style="color: red">{{ totalNum }}</span>件</span>
                </div>
             </el-form-item>

          </el-form>
        </div>
        <!-- 表格 -->
        <div :style="{ height: h }">
          <el-table height="100%" size="mini" ref="tabref1" :data="tableData" style="width: 100%"
            :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row
            @row-click="dianjixuanzhong" border center bordersize="mini" class="tableComent">
            <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
            <el-table-column align="center" label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text" @click="lookImg(scope.row)" size="mini">查看单据</el-button>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" align="center" width="220">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockUser" label="入库人" align="center" width="100">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库时间" align="center" width="180"
              :formatter="dateTimeFormat"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="入库车牌号" align="center"
              width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center"
              width="220"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="220">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机姓名" align="center" width="100">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" align="center" width="120">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" align="center" width="150">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center" width="100">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="vehicleNumber" label="车船号" align="center" width="100">
            </el-table-column>

            <!-- <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="数据来源" align="center" width="150"></el-table-column> -->
            <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center" width="100">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center" width="180"
              :formatter="dateTimeFormat"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="ext1" label="备注" align="center" width="150">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="warehousingNo" label="出厂编号" align="center" width="150">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center" width="150"></el-table-column>
          </el-table>
        </div>
        <!--分页-->
        <div class="pags" style="text-align: right">
          <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
            :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
            layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total">
          </el-pagination>
        </div>
        <!--货物详情-->
        <div style="">
          <div class="detailsTitle">
            <h4>货物详情</h4>
          </div>
          <div ref="searchBox2" style="margin-top: 5px;margin-left:10px;">
            <span>
              总吨数:
              <span style="color: red">{{ allWeight }}</span> &nbsp;吨
            </span>
            <span style="margin-left: 15px">
              总件数:
              <span style="color: red">{{ allnumber }}</span> &nbsp;件
            </span>
          </div>
          <!--详情表格-->
          <div class="ruKuZuoyeWarp-body-detailsTab">
            <div class="ruKuZuoyeWarp-body-table" :style="{ height: detailsH }">
              <el-table height="100%" size="mini" ref="tabref" :data="detailsData" style="width: 100%"
                :header-cell-style="{ background: '#F5F5F5', color: 'black', }" class="tableComent"
                  highlight-current-row @row-click="dianjixuanzhongdown" border center bordersize="mini">
                <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
                  width="100"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"
                  width="180"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
                  width="100"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="100">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="singletonWeight" label="单件理重（吨）" align="center"
                  width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="70">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center"
                  width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" align="center" width="100">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重(吨)" align="center"
                  width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="实际过磅时间" align="center"
                  width="180" :formatter="dateTimeFormat"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重（吨）" align="center"
                  width="150">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="outNumber" label="出厂车号" align="center" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center"
                  width="100"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" align="center" width="150">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="queueForwardUnit" label="发货单位" align="center" width="130"></el-table-column>
              </el-table>
            </div>
            <!--分页-->
            <div class="pags" style="text-align: right">
              <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="pageInfoXQ.pageNo"
                :page-size="pageInfoXQ.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
                layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ" :total="totalXQ">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
     <!-- 上传凭证 -->
    <el-dialog title="上传凭证" :visible.sync="scpzMark" @close="scpzMark = false" width="40%" center>
      <!--form表单-->
      <div class="imgBox" >
          <uploadImgs3 :imgList.sync='arrImg'  v-if="scpzMark" :max=5 ></uploadImgs3>
        </div>
      <div style="width: 150px; margin: 15px auto">
        <el-button type="" @click="scpzMark = false">取 消</el-button>
        <el-button type="primary" @click="scpzSave()">确 定</el-button>

      </div>
    </el-dialog>
    <!-- 查看单据 -->
    <dj-dialog v-if="CKDJVisible" :CKDJVisible.sync='CKDJVisible' :instockId="instockId"></dj-dialog>
    <!-- 打印榜单 -->
    <dayinbangdan v-if="DYBDVisible" :DYBDVisible.sync='DYBDVisible' :ziRowData="ziRowData" :rowData="xuanzhongArr"></dayinbangdan>
  </div>
</template>

<script>
import {
  JfgetThreadExpList,
  JfgetThreadDetailExpList,
  JfgetThreadDetailExpWN,
  JfgetThreadExpWeightp,
  saveInStockReceipt
} from '@/api/wms-access'

import {
  getRelationCustomer
} from '@/api/wms-stock'
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  dateTimeFormat,
  dateFormat1
} from '@/utils/util'

import {
  exportExcel
} from '@/utils/fileDown.js'
import djDialog from '../dialog/DJindex.vue'
import dayinbangdan from '../dialog/dayinbangdan.vue'
import uploadImgs3 from '@/components/uploadImgs3.vue'
export default {
  components: {
    djDialog, uploadImgs3, dayinbangdan
  },
  data () {
    return {
      formData: {
        instockNo: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        instockPlateNumber: '',
        instockDateEnd: dateFormat1(new Date().getTime(), 'YYYY-MM-ss h-m-s'),
        instockDateStart: dateFormat1(new Date().getTime() - 1000 * 60 * 60 * 24 * 15, 'YYYY-MM-ss h-m-s'),
        arrivalMethod: ''
      },
      RKData: [],
      btnFlg: [],
      tableData: [],
      allWeight: '0',
      allnumber: '0',
      btnIdArr: [
        '00ZP002B001',
        '00ZP002B002',
        '00ZP002B003',
        '00ZP002B004',
        '00ZM0A0100', '00ZM0A0200', '00ZM0A0300'
      ],
      detailsH: '200px',
      h: '200px',
      detailsData: [], // 详情数据
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      pageInfoXQ: {
        pageSize: 20,
        pageNo: 1
      },
      currentXQ: 1,
      total: 0,
      totalXQ: 0,
      xuanzhongArr: null,
      xuanzhongArrdown: null,
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      totalTon: 0, // 主表总吨数
      totalNum: 0, // 主表总件数
      arrivalMethodData: [{
        value: '1',
        label: '火运'
      },
      {
        value: '2',
        label: '汽运'
      },
      {
        value: '3',
        label: '船运'
      }
      ],
      // 查看单据
      CKDJVisible: false,
      instockId: '',
      scpzMark: false,
      arrImg: [],
      isDisable: true,
      DYBDVisible: false, // 打印榜单
      ziRowData: {}// 打印绑定需要或者子表数据
    }
  },
  methods: {
    daYinBd () {
      if (this.xuanzhongArr) {
        this.DYBDVisible = true
      }
    },
    // 点击上传凭证
    uploadClick () {
      if (this.xuanzhongArr) {
        this.scpzMark = true
        this.arrImg = []
      }
    },
    // 点击确认-上传凭证
    scpzSave () {
      this.isDisable = true
      if (this.arrImg.length == 0) {
        DonMessage.error('请选择需要上传的图片!')
      } else {
        let imgfile = new FormData()
        for (var i = 0; i < this.arrImg.length; i++) {
          imgfile.append('files', this.arrImg[i].raw)
        }
        let numId = { instockId: this.xuanzhongArr.instockId }
        imgfile.append('params', JSON.stringify(numId))
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        saveInStockReceipt(imgfile)
          .then(res => {
            DonMessage.success('操作成功!')
            this.scpzMark = false
            loading.close()
          })
          .catch(err => {
            DonMessage.error(err.message)
          })
      }
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 5000)
      // this.saveChangeMasterPictureS();
    },
    // 查看单据
    lookImg (row) {
      this.CKDJVisible = true
      this.instockId = row.instockId
    },
    JfgetThreadExpWeightp () {
      JfgetThreadExpWeightp({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        instockNo: this.formData.instockNo,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        instockPlateNumber: this.formData.instockPlateNumber,
        instockStatus: 1,
        instockDateStart: this.formData.instockDateStart,
        instockDateEnd: this.formData.instockDateEnd,
        arrivalMethod: this.formData.arrivalMethod
      })
        .then(res => {
          this.totalTon = res.totalAllWeight
          this.totalNum = res.totalAllNumber
        })
        .catch(err => {
          this.message({
            message: err.message,
            type: 'error'
          })
        })
    },
    daochu () {
      exportExcel(
        this.global.wmsAccessName + '/instockThread/exportInThreadMasterList', {
          ...this.formData,
          instockStatus: '1'
        },
        '入库单据表'
      )
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.JfgetThreadDetailExpLists()
    },
    dianjixuanzhongdown (row) {
      this.xuanzhongArrdown = {}
      this.xuanzhongArrdown = row
    },
    chaxun () {
      this.JfgetThreadExpLists()
    },
    chongZhi () {
      this.formData.instockNo = ''
      this.formData.customerTaxId = ''
      this.formData.primaryCustomerTaxId = ''
      this.formData.instockPlateNumber = ''
      this.formData.instockDateStart = ''
      this.formData.instockDateEnd = ''
      this.formData.arrivalMethod = ''

      this.JfgetThreadExpLists()
    },
    daYin (n) {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      this.$router.push({
        path: '/rukuDanPrint',
        query: {
          id: this.xuanzhongArr.instockId,
          flag: n// 1为首线lianhe
        }
      })
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetThreadExpLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetThreadExpLists()
    },
    handleCurrentChangeXQ (val) {
      this.pageInfoXQ.pageNo = val
      this.JfgetThreadDetailExpLists()
    },
    handleSizeChangeXQ (val) {
      this.pageInfoXQ.pageSize = val
      this.JfgetThreadDetailExpLists()
    },
    // 主列表显示
    JfgetThreadExpLists () {
      JfgetThreadExpList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        instockNo: this.formData.instockNo,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        instockPlateNumber: this.formData.instockPlateNumber,
        instockStatus: 1,
        instockDateStart: this.formData.instockDateStart,
        instockDateEnd: this.formData.instockDateEnd,
        arrivalMethod: this.formData.arrivalMethod
      })
        .then(res => {
          this.tableData = res.list
          if (res.list.length > 0) {
            this.xuanzhongArr = res.list[0]
            this.$nextTick(() => {
              this.$refs.tabref1.setCurrentRow(res.list[0])
            })
            this.JfgetThreadDetailExpLists()
            this.JfgetThreadExpWeightp()
          } else {
            this.detailsData = []
            this.allWeight = 0
            this.allnumber = 0
            this.totalXQ = 0
            this.totalTon = 0
            this.totalNum = 0
          }
          this.total = res.total
        })
        .catch(error => {
          DonMessage.error(error)
        })
    },
    // 货物详情
    JfgetThreadDetailExpLists () {
      JfgetThreadDetailExpList({
        instockId: this.xuanzhongArr.instockId,
        ...this.pageInfoXQ
      })
        .then(res => {
          this.detailsData = res.list
          this.xuanzhongArrdown = res.list[0]
          this.$nextTick(() => {
            this.$refs.tabref.setCurrentRow(res.list[0])
            this.ziRowData = res.list[0]
          })
          this.totalXQ = res.total

          this.JfgetThreadDetailExpWNs()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 总重量
    JfgetThreadDetailExpWNs () {
      JfgetThreadDetailExpWN({
        instockId: this.xuanzhongArr.instockId
      })
        .then(res => {
          this.allWeight = res.totalAllWeight
          this.allnumber = res.totalNumber
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/jfRkReceipts')
    this.getRelationCustomerS()
    this.JfgetThreadExpLists()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 135 + 'px'
    this.detailsH = 0.4 * pH - h2 - 120 + 'px'
  }
}

</script>

<style lang="less" scoped>
  .inpBox {
    .el-form-item {
      margin-left: 10px;
      margin-bottom: 0px;
    }
  }

  .ruKuZuoyeWarp {
    width: 100%;
    position: relative;
  }
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
